import { FETCH_SUCCESS, FETCH_START, FETCH_FAILURE } from './actionTypes'

export const fetchSuccess = layers => ({
  type: FETCH_SUCCESS,
  layers
})

export const fetchStart = () => ({
  type: FETCH_START
})

export const fetchFail = error => ({
  type: FETCH_FAILURE,
  error
})
